import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './endpoints-panel.css';
import HeaderBreadcrumb from '../../components/header-breadcrumb/HeaderBreadcrumb';
import EndpointList from './endpoint-list/EndpointList';
import { NavLink, Route } from 'react-router-dom';
import EndpointCreator from './endpoint-creator/EndpointCreator';
import EndpointEditor from './endpoint-editor/EndpointEditor';

class EndpointsPanel extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			activePage: this.getActivePath()
		};
		this.autoBind(['onBack', 'onCreateEndpoint', 'onEditEndpoint', 'onTestEndpoint', 'getHeaderText']);
	}

	getActivePath = () => {
		return this.props.location.pathname === '/endpoints' ? 'list' : 'creator';
	};

	onBack() {
		this.setData('activePage', 'list');
	}

	onCreateEndpoint() {
		this.setData('activePage', 'creator');
	}

	onEditEndpoint(endpoint) {
		this.observe(() => {
			this.data.editing = endpoint;
			this.data.activePage = 'editor';
		});
	}

	onTestEndpoint(endpoint) {
		this.observe(() => {
			this.data.editing = endpoint;
			this.data.activePage = 'testing';
		});
	}

	getHeaderText() {
		switch (this.data.activePage) {
			case 'list': {
				return 'Endpoints';
			}
			case 'creator': {
				return 'New Endpoint';
			}
			case 'editor': {
				return 'Edit Endpoint';
			}
			case 'testing': {
				return 'Test Endpoint';
			}
			default: {
				return 'Endpoints';
			}
		}
	}

	buildHeaderButtons = () => {
		let { match } = this.props;
		if (this.props.location.pathname !== '/endpoints') {
			return (
				<NavLink to={`${match.url}`}>
					<button className="btn" data-page="list" onClick={this.onBack}>
						Back
					</button>
				</NavLink>
			);
		}
		return '';
	};

	render() {
		let { activePage, editing } = this.data;
		let { match } = this.props;
		return (
			<div className="endpoints-panel-view animated fadeIn">
				<div className="header hbox">
					<HeaderBreadcrumb currentPage={this.getHeaderText()} className="grow-1" />
					{this.buildHeaderButtons()}
				</div>
				{activePage === 'list' && (
					<div className="sub-title">
						Endpoints are sets of configurations that to connect to an external service such as a REST API, a MySQL server, a SOAP service, etc.
					</div>
				)}
				<Route
					exact
					path={`${match.url}`}
					render={routeProps => (
						<EndpointList
							{...routeProps}
							onCreateEndpoint={this.onCreateEndpoint}
							onEditEndpoint={this.onEditEndpoint}
							onTestEndpoint={this.onTestEndpoint}
							key="endpoint-list-on-panel-key"
						/>
					)}
				/>
				<Route path={`${match.url}/create`} component={EndpointCreator} />
				<Route path={`${match.url}/edit`} render={routeProps => <EndpointEditor {...routeProps} editing={editing} />} />
			</div>
		);
	}
}

export default EndpointsPanel;



// WEBPACK FOOTER //
// ./src/views/endpoints-panel/EndpointsPanel.js